<template>
  <div class="pb-4">
    <h4 class="text-center"><font-awesome-icon icon="cog" class="mr-1"/> {{$t('networkTransfers.physicsOptions.graphBehaviourSettings')}}</h4>
    <!-- Save/Load -->
    <div v-show="false" class="row gutters-tiny text-center mt-4">
      <div class="col-6 mb-1">
        <button class="btn btn-block py-3 bg-body-dark font-w600 text-dark" disabled>Save</button>
      </div>
      <div class="col-6 mb-1">
        <button class="btn btn-block py-3 bg-body-dark font-w600 text-dark" disabled>Load</button>
      </div>
    </div>
    <!-- END Save/Load -->
    <!-- Solver -->
    <div>
      <h5 class="text-center mt-3 mb-1">{{$t('networkTransfers.physicsOptions.physics')}}</h5>
      <div class="form-group">
        <label for="solver-select">{{$t('networkTransfers.physicsOptions.solver')}}</label>
        <select v-model="selectedSolver" class="form-control mb-4" id="solver-select" name="solver-select">
          <option value="barnesHut">{{$t('networkTransfers.physicsOptions.barnesHut')}}</option>
          <option value="forceAtlas2Based">{{$t('networkTransfers.physicsOptions.forceAtlas2Based')}}</option>
          <option value="repulsion">{{$t('networkTransfers.physicsOptions.repulsion')}}</option>
          <option value="hierarchicalRepulsion">{{$t('networkTransfers.physicsOptions.hierarchicalRepulsion')}}</option>
        </select>
      </div>
      <div v-if="selectedSolver === 'barnesHut' || selectedSolver === 'forceAtlas2Based'" class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.gravitationalConstant')}} {{ gravitationalConstant }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="gravitationalConstant" v-bind="options[selectedSolver].gravitationalConstant"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.centralGravity')}} {{ centralGravity }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="centralGravity" v-bind="options[selectedSolver].centralGravity"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.springConstant')}} {{ springConstant }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="springConstant" v-bind="options[selectedSolver].springConstant"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.springLength')}} {{ springLength }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="springLength" v-bind="options[selectedSolver].springLength"></vue-slider>
      </div>
      <div v-if="selectedSolver === 'repulsion' || selectedSolver === 'hierarchicalRepulsion'" class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.nodeDistance')}} {{ nodeDistance }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="nodeDistance" v-bind="options[selectedSolver].nodeDistance"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.damping')}} {{ damping }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="damping" v-bind="options[selectedSolver].damping"></vue-slider>
      </div>
      <div v-if="selectedSolver === 'barnesHut' || selectedSolver === 'forceAtlas2Based'" class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.avoidOverlap')}} {{ avoidOverlap }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="avoidOverlap" v-bind="options[selectedSolver].avoidOverlap"></vue-slider>
      </div>
    </div>
    <!-- END Solver -->

    <!-- Solver Advanced -->
    <div>
      <h5 class="text-center mt-4 mb-3">{{$t('networkTransfers.physicsOptions.simulation')}}</h5>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.velocityMin')}} {{ minVelocity }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="minVelocity" v-bind="options.advanced.minVelocity"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.velocityMax')}} {{ maxVelocity }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="maxVelocity" v-bind="options.advanced.maxVelocity"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.timestep')}} {{ timestep }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="timestep" v-bind="options.advanced.timestep"></vue-slider>
      </div>
    </div>
    <!-- END Solver Advanced -->

    <!-- Nodes Advanced -->
    <div>
      <h5 class="text-center mt-4 mb-3">{{$t('networkTransfers.physicsOptions.nodes')}}</h5>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.nodeSize')}} {{ nodeSize }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="nodeSize" v-bind="options.advanced.nodeSize"></vue-slider>
      </div>
      <div class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.labelSize')}} {{ labelSize }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="labelSize" v-bind="options.advanced.labelSize"></vue-slider>
      </div>
      <div class="form-group">
        <label for="node-shape">{{$t('networkTransfers.physicsOptions.shape')}}</label>
        <select v-model="nodeShape" class="form-control mb-4" id="node-shape" name="node-shape">
          <option value="dot">{{$t('networkTransfers.physicsOptions.circle')}}</option>
          <option value="square">{{$t('networkTransfers.physicsOptions.square')}}</option>
          <option value="diamond">{{$t('networkTransfers.physicsOptions.diamond')}}</option>
          <option value="hexagon">{{$t('networkTransfers.physicsOptions.hexagon')}}</option>
          <option value="star">{{$t('networkTransfers.physicsOptions.star')}}</option>
          <option value="triangle">{{$t('networkTransfers.physicsOptions.triangle')}}</option>
          <option value="triangleDown">{{$t('networkTransfers.physicsOptions.triangleDown')}}</option>
        </select>
      </div>
    </div>
    <!-- END Nodes Advanced -->

    <!-- Edges Advanced -->
    <div>
      <h5 class="text-center mt-4 mb-3">{{$t('networkTransfers.physicsOptions.edges')}}</h5>
      <div class="form-group">
        <label for="edge-type">{{$t('networkTransfers.physicsOptions.smoothEdgesType')}}</label>
        <select v-model="edgeType" class="form-control mb-4" id="edge-type" name="edge-type">
          <option value="none">{{$t('networkTransfers.physicsOptions.disableSmooth')}}</option>
          <option value="dynamic">{{$t('networkTransfers.physicsOptions.dynamic')}}</option>
          <option value="continuous">{{$t('networkTransfers.physicsOptions.continuous')}}</option>
          <option value="discrete">{{$t('networkTransfers.physicsOptions.discrete')}}</option>
          <option value="diagonalCross">{{$t('networkTransfers.physicsOptions.diagonalCross')}}</option>
          <option value="straightCross">{{$t('networkTransfers.physicsOptions.straightCross')}}</option>
          <option value="horizontal">{{$t('networkTransfers.physicsOptions.horizontal')}}</option>
          <option value="vertical">{{$t('networkTransfers.physicsOptions.vertical')}}</option>
          <option value="curvedCW">{{$t('networkTransfers.physicsOptions.curvedCW')}}</option>
          <option value="curvedCCW">{{$t('networkTransfers.physicsOptions.curvedCCW')}}</option>
          <option value="cubicBezier">{{$t('networkTransfers.physicsOptions.cubicBezier')}}</option>
        </select>
      </div>
      <div v-if="!(edgeType === 'none' || edgeType === 'dynamic')" class="my-1">
        <p class="m-0">{{$t('networkTransfers.physicsOptions.roundness')}} {{ edgeRoundness }}<font-awesome-icon icon="question-circle" class="fa-pull-right text-muted mt-1 mr-2"/></p>
        <vue-slider ref="slider" v-model="edgeRoundness" v-bind="options.advanced.edgeRoundness"></vue-slider>
      </div>
    </div>
    <!-- END Edges Advanced -->
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  components: {
    vueSlider
  },
  computed: {
    selectedSolver: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics.solver
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solver', 'selected', value)
      }
    },
    gravitationalConstant: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].gravitationalConstant
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'gravitationalConstant', value)
      }
    },
    centralGravity: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].centralGravity
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'centralGravity', value)
      }
    },
    springLength: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].springLength
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'springLength', value)
      }
    },
    springConstant: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].springConstant
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'springConstant', value)
      }
    },
    damping: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].damping
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'damping', value)
      }
    },
    avoidOverlap: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].avoidOverlap
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'avoidOverlap', value)
      }
    },
    nodeDistance: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics[this.selectedSolver].nodeDistance
      },
      // setter
      set (value) {
        this.updateNetworkOptions('solverParam', 'nodeDistance', value)
      }
    },
    minVelocity: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics.minVelocity
      },
      // setter
      set (value) {
        this.updateNetworkOptions('physics', 'minVelocity', value)
      }
    },
    maxVelocity: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics.maxVelocity
      },
      // setter
      set (value) {
        this.updateNetworkOptions('physics', 'maxVelocity', value)
      }
    },
    timestep: {
      // getter
      get () {
        return this.$store.state.network.networkPhysics.timestep
      },
      // setter
      set (value) {
        this.updateNetworkOptions('physics', 'timestep', value)
      }
    },
    nodeSize: {
      // getter
      get () {
        return this.$store.state.network.network.options.nodes.size
      },
      // setter
      set (value) {
        this.updateNetworkOptions('nodes', 'size', value)
      }
    },
    labelSize: {
      // getter
      get () {
        return this.$store.state.network.network.options.nodes.font.size
      },
      // setter
      set (value) {
        this.updateNetworkOptions('nodes', 'labelSize', value)
      }
    },
    nodeShape: {
      // getter
      get () {
        return this.$store.state.network.network.options.nodes.shape
      },
      // setter
      set (value) {
        this.updateNetworkOptions('nodes', 'shape', value)
      }
    },
    edgeType: {
      // getter
      get () {
        return this.$store.state.network.network.options.edges.smooth.type
      },
      // setter
      set (value) {
        if (value === 'none') {
          this.updateNetworkOptions('edgesSmooth', 'enabled', false)
          this.updateNetworkOptions('edgesSmooth', 'type', value)
        } else {
          this.updateNetworkOptions('edgesSmooth', 'enabled', true)
          this.updateNetworkOptions('edgesSmooth', 'type', value)
        }
      }
    },
    edgeRoundness: {
      // getter
      get () {
        return this.$store.state.network.network.options.edges.smooth.roundness
      },
      // setter
      set (value) {
        this.updateNetworkOptions('edgesSmooth', 'roundness', value)
      }
    }
  },
  methods: {
    updateNetworkOptions (category, key, value) {
      this.$store.commit('updateNetworkOptions', { category: category, option: { key: key, value: value } })
    }
  },
  data () {
    return {
      options: {
        barnesHut: {
          gravitationalConstant: {
            height: 10,
            min: -50000,
            max: -100,
            interval: 100,
            tooltip: false,
            lazy: true
          },
          centralGravity: {
            height: 10,
            min: 0,
            max: 10,
            interval: 0.05,
            tooltip: false,
            lazy: true
          },
          springLength: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          springConstant: {
            height: 10,
            min: 0,
            max: 0.1,
            interval: 0.005,
            tooltip: false,
            lazy: true
          },
          damping: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          },
          avoidOverlap: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          }
        },
        forceAtlas2Based: {
          gravitationalConstant: {
            height: 10,
            min: -1000,
            max: -2,
            interval: 2,
            tooltip: false,
            lazy: true
          },
          centralGravity: {
            height: 10,
            min: 0,
            max: 0.2,
            interval: 0.005,
            tooltip: false,
            lazy: true
          },
          springLength: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          springConstant: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.005,
            tooltip: false,
            lazy: true
          },
          damping: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          },
          avoidOverlap: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          }
        },
        repulsion: {
          centralGravity: {
            height: 10,
            min: 0,
            max: 10,
            interval: 0.05,
            tooltip: false,
            lazy: true
          },
          springLength: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          springConstant: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.005,
            tooltip: false,
            lazy: true
          },
          nodeDistance: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          damping: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          }
        },
        hierarchicalRepulsion: {
          centralGravity: {
            height: 10,
            min: 0,
            max: 10,
            interval: 0.05,
            tooltip: false,
            lazy: true
          },
          springLength: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          springConstant: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.005,
            tooltip: false,
            lazy: true
          },
          nodeDistance: {
            height: 10,
            min: 0,
            max: 500,
            interval: 5,
            tooltip: false,
            lazy: true
          },
          damping: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.01,
            tooltip: false,
            lazy: true
          }
        },
        advanced: {
          minVelocity: {
            height: 10,
            min: 0.5,
            max: 20,
            interval: 0.5,
            tooltip: false,
            lazy: true
          },
          maxVelocity: {
            height: 10,
            min: 1,
            max: 150,
            interval: 1,
            tooltip: false,
            lazy: true
          },
          timestep: {
            height: 10,
            min: 0.1,
            max: 1,
            interval: 0.1,
            tooltip: false,
            lazy: true
          },
          nodeSize: {
            height: 10,
            min: 6,
            max: 30,
            interval: 1,
            tooltip: false,
            lazy: true
          },
          labelSize: {
            height: 10,
            min: 6,
            max: 50,
            interval: 1,
            tooltip: false,
            lazy: true
          },
          edgeRoundness: {
            height: 10,
            min: 0,
            max: 1,
            interval: 0.1,
            tooltip: false,
            lazy: true
          }
        }
      }
    }
  }
}
</script>
